import React from 'react';
import SureLoader from './SureLoader';

const ProgressComponent = () => {
    return (
        <div style={{ textAlign: 'center', padding: '20px', background: 'transparent'}}>
            <SureLoader/>
        </div>
    );
};

export default ProgressComponent;